module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAA3SURBVDiNY/yfJ/6fgQqAiRqGUNUgFlRjGR0ZGBgeUG4QA8MDxgkvyDJo8IXRqEGjBo0ahBcAAMACBwhR6RDdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr-code-1.png
// module id = LoJa
// module chunks = 1